import React from 'react';

import '../App.scss';
import Header from '../Component/Header';
import Main from '../Component/Main';
import Caraousel from '../Component/Caraousel';
import Footer from '../Component/Footer';
import Header2 from '../Component/Header2';

const Home = () => {
  return (
    <div className="App">
      <Header2 />
      <Header home={true} />
      <Caraousel />
      <Main />
      <Footer />
    </div>
  );
}

export default Home;